import Model from './Model'
import get from 'lodash/get'
export default class Workstation extends Model {

    baseURL() {
        return `${window.App.api_endpoint}/api`
    }

    resource()
    {
        return 'workstations'
    }

    get vat_no() {
        return this.data?.company_vat
    }

    get full_address() {
        return `${get(this.data, 'company_address')} ${get(this.data, 'company_address_no')}, ${get(this.data, 'company_city')}`
    }
}
